/* Name matching and folder paths.
   ===============================
*/

/* Lowercase, trimmed, runs of whitespace collapsed. For COMPARING names, never
   for displaying them — "  Maria   Lopez " and "maria lopez" are the same
   person and should not import as two. */
export function normName(s) {
  return (s || '').toString().toLowerCase().trim().replace(/\s+/g, ' ');
}

/* The last seven digits of a phone number, ignoring formatting. Seven rather
   than ten because the same person is often stored with and without an area
   code, and the local part is enough to tell two clients apart in one team. */
export function phoneTail(s) {
  return (s || '').toString().replace(/\D/g, '').slice(-7);
}

/* The key used to spot a duplicate person on import. Name alone is too loose
   (two Maria Lopezes), phone alone too strict (plenty have none). */
export function personDedupKey(o) {
  return normName(o.name) + '|' + phoneTail(o.phone);
}

/* Folders are stored as slash-separated paths — "Clients/Maria Lopez" — rather
   than as a tree, so these three functions are the entire folder model. */
export function folderDepth(path) {
  return (String(path || '').match(/\//g) || []).length;
}

export function folderLeaf(path) {
  const p = String(path || '');
  const i = p.lastIndexOf('/');
  return i === -1 ? p : p.slice(i + 1);
}

/* A folder is its own descendant, which is what callers want: deleting a
   folder should take the folder itself as well as everything under it. The
   trailing slash matters — without it "Clients" would match "ClientsOld". */
export function folderIsDescendant(path, maybeAncestor) {
  return path === maybeAncestor || String(path).startsWith(maybeAncestor + '/');
}
